import React, { useEffect } from 'react';
import { Form, Input, Button, message, Typography } from 'antd';
import { UserOutlined, LockOutlined } from '@ant-design/icons';
import { useLocation, useNavigate } from 'react-router-dom';
import { useAuthStore } from '../../store/authStore';
import './index.css';

const { Text } = Typography;

interface LoginFormData {
  username: string;
  password: string;
}

const LoginMinimalPage: React.FC = () => {
  const [form] = Form.useForm<LoginFormData>();
  const navigate = useNavigate();
  const location = useLocation();
  const { login, loading, error, clearError, isAuthenticated } = useAuthStore();

  useEffect(() => {
    if (isAuthenticated) {
      const from = (location.state as any)?.from?.pathname || '/dashboard';
      navigate(from, { replace: true });
    }
  }, [isAuthenticated, navigate, location]);

  useEffect(() => {
    if (error) {
      message.error(error);
      clearError();
    }
  }, [error, clearError]);

  const handleLogin = async (values: LoginFormData) => {
    const result = await login(values);

    if (result.success) {
      message.success(result.message);
      const from = (location.state as any)?.from?.pathname || '/dashboard';
      navigate(from, { replace: true });
      return;
    }
    message.error(result.message);
  };

  return (
    <div className="login-minimal-root">
      <div className="login-minimal-panel">
        <div className="login-minimal-header">
          <h1 className="login-minimal-title">斌宇林建</h1>
          <p className="login-minimal-subtitle">项目管理系统</p>
        </div>

        <Form
          form={form}
          name="login-minimal"
          onFinish={handleLogin}
          layout="vertical"
          size="large"
          className="login-minimal-form"
          requiredMark={false}
        >
          <Form.Item
            name="username"
            rules={[
              { required: true, message: '请输入用户名' },
              { min: 3, message: '用户名至少3个字符' },
              { max: 30, message: '用户名不能超过30个字符' },
              { pattern: /^[a-zA-Z0-9_]+$/, message: '用户名只能包含字母、数字和下划线' },
            ]}
          >
            <Input prefix={<UserOutlined />} placeholder="用户名" autoComplete="username" />
          </Form.Item>

          <Form.Item name="password" rules={[{ required: true, message: '请输入密码' }]}>
            <Input.Password prefix={<LockOutlined />} placeholder="密码" autoComplete="current-password" />
          </Form.Item>

          <div className="login-minimal-actions">
            <Button type="primary" htmlType="submit" loading={loading}>
              登录
            </Button>
          </div>
        </Form>

        <div className="login-minimal-footnote">
          <Text type="secondary">仅内部使用</Text>
        </div>
      </div>
    </div>
  );
};

export default LoginMinimalPage;
